import { Column } from './column';
import { RenderStation } from './renderStation';

export class Station {
  #queue = [];
  #filling = [];
  #ready = [];
  constructor(typeStation, renderApp = null) {
    this.typeStation = typeStation;
    this.renderApp = renderApp;
    this.renderStation = null;
  }

  get filling() {
    return this.#filling;
  }

  get queue() {
    return this.#queue;
  }

  init() {
    this.renderGasStationsInApp();
    setInterval(() => {
      this.checkQueueToFilling();
    }, 2000);
  }

  renderGasStationsInApp() {
    for (const optionStation of this.typeStation) {
      if (!optionStation.count) {
        // if there is no number of stations in the type
        this.addColumnGasStation(optionStation);
      } else {
        for (let i = 0; i < optionStation.count; i++) {
          this.addColumnGasStation(optionStation);
        }
      }
    }

    if (this.renderApp) {
      this.renderStation = new RenderStation(this.renderApp, this);
    }
  }

  addColumnGasStation(optionStation) {
    this.#filling.push(new Column(optionStation.type, optionStation.speed));
  }

  checkQueueToFilling() {
    if (this.#queue.length) {
      for (let i = 0; i < this.#queue.length; i++) {
        for (let j = 0; j < this.#filling.length; j++) {
          if (!this.#filling[j].car &&
            this.#queue[i].typeFuel === this.#filling[j].type) {
            this.#filling[j].car = this.#queue.splice(i, 1)[0];
            this.fillingGo(this.#filling[j]);
            if (this.#ready.length) {
              this.renderStation.renderStation(this.#ready);
            } else {
              this.renderStation.renderStation(null);
            }

            break;
          }
        }
      }
    }
  }

  fillingGo(column) {
    const car = column.car;
    const needPetrol = car.needPetrol;
    let nowTank = car.nowTank;
    const timerId = setInterval(() => {
      nowTank += column.speed;
      this.renderStation.renderCheckFuel(car, nowTank);
      if (nowTank >= car.maxTank) {
        clearInterval(timerId);
        const total = car.nowTank - needPetrol;
        car.fillUp();
        column.car = null;
        this.leaveClient({ car, total });
      }
    }, 1000);
  }

  leaveClient({ car, total }) {
    this.#ready.push(car);
    this.renderStation.renderStation(this.#ready);
  }

  addCarQueue(car) {
    this.#queue.push(car);
    if (this.#ready.length) {
      this.renderStation.renderStation(this.#ready);
    } else {
      this.renderStation.renderStation(null);
    }

  }
}
